/* React's view of the domain vocabulary.
 *
 * Rebuilt only when the language changes, so a table of two hundred rows
 * resolves its order-type names through one object rather than constructing a
 * new resolver per cell.
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { createVocabulary, type Vocabulary } from '@/shared/domain/vocabulary';

export function useVocabulary(): Vocabulary {
  const { t } = useTranslation('domain');
  return useMemo(() => createVocabulary(t), [t]);
}
